// @greenlight-spec: decisions/0026-integration-catalog-and-connection-profiles.md
// @greenlight-spec: 09-data-brokering.md
/**
 * Datadog API key + application key registration guide.
 *
 * Datadog reads need both keys on every request, so one credential holds the
 * pair and the proxy fills DD-API-KEY and DD-APPLICATION-KEY from it.
 */
export const DATADOG_API_KEY_STEPS = [
    {
        title: 'Pick the site your Datadog org is on',
        body: 'The site is in the address you sign in at: app.datadoghq.com is datadoghq.com, app.datadoghq.eu is datadoghq.eu, us3.datadoghq.com is us3.datadoghq.com, and so on. Enter it in Datadog site on this form.',
        details: 'Calls to a site the org is not on are rejected. On a custom domain, the site is shown at the top of My Preferences in Datadog.',
    },
    {
        title: 'Create an API key',
        body: 'In Datadog, open Organization Settings → API Keys, select New Key, and name it for this integration. Paste it in API key on this form.',
    },
    {
        title: 'Create an application key owned by a service account',
        body: 'Open Organization Settings → Service Accounts, choose New Service Account, and give it the Datadog Read Only Role unless apps write. Open the account and, under Application Keys rather than Access Tokens, choose New Key. Copy the key when it is shown, because Datadog shows a service account’s key only once, and paste it in Application key on this form.',
        details: 'Datadog revokes a person’s application keys when their account is disabled. A key owned by a service account keeps working when people leave. Datadog recommends Service Access Tokens in this panel; this integration sends an API key and an application key, so a token does not fit it.',
    },
    {
        title: 'Limit the application key to the scopes the app needs',
        body: 'In the new key’s Scopes row, choose Edit and request only the scopes the app uses, such as monitors_read or metrics_read. An unscoped key carries every permission of its service account.',
    },
    {
        title: 'Repeat the API key in each pair',
        body: 'To register several key pairs on one Datadog integration, such as a read pair and a monitor-write pair, enter the same API key in each. When the API key rotates, replace it in every pair.',
    },
];
//# sourceMappingURL=datadog-api-keys-guide.js.map